<template>
  <div>
    <div class="relative mt-4">
      <div
        v-if="!!history"
        class="
          absolute
          left-0
          bg-white
          w-auto
          right-4
          top-4
          flex
          gap-4
          p-2
          rounded-md
          shadow-md
        "
        style="z-index: 1000; width: fit-content"
      >
        <Field
          v-if="history.company_vehicle.driver"
          :title="$t('DRIVER_TITLE')"
          type="col"
          align="center"
        >
          <p>
            {{
              history.company_vehicle.driver.first_name +
              ' ' +
              history.company_vehicle.driver.last_name
            }}
          </p>
        </Field>

        <Field
          v-if="history.length"
          :title="$t('ODOMETER')"
          type="col"
          align="center"
        >
          <p>
            {{ history.length / 1000 }}
          </p>
        </Field>
      </div>

      <HintLabels
        :colors="colors"
        :labels="anomalyTypes"
        class="
          lg:absolute
          bg-white
          lg:bottom-0
          lg:left-4
          z-50
          lg:p-2
          rounded-md
          lg:shadow-md
        "
      />
      <div id="map" ref="mapElement"></div>
    </div>

    <div
      v-if="history && history.stops && history.stops.length > 0"
      class="mt-6"
    >
      <div class="flex justify-between items-center mb-4">
        <h3 class="text-lg font-semibold mb-4">{{ $t('stops_in_order') }}</h3>
        <el-button
          :loading="isDownloadLoading"
          type="info"
          size="small"
          round
          @click="downloadReport()"
        >
          {{ $t('DOWNLOAD_STOP_LIST') }}
        </el-button>
      </div>
      <div class="stops-table-container">
        <el-table
          :data="history.stops"
          :empty-text="$t('NO_DATA')"
          style="width: 100%"
          :stripe="true"
          @row-click="handleStopRowClick"
          class="stops-table cursor-pointer"
          :height="300"
        >
          <el-table-column
            type="index"
            :align="$i18n.locale == 'fa' ? 'right' : 'left'"
            :label="$t('INDEX')"
            width="100"
          >
            <template slot-scope="scope">
              <div class="font-semibold text-red-600" :data-title="$t('INDEX')">
                {{ scope.$index + 1 }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            :align="$i18n.locale == 'fa' ? 'right' : 'left'"
            :label="$t('DURATION') + ' (' + $t('HOUR') + ')'"
            width="250"
          >
            <template slot-scope="scope">
              <div
                class="font-medium"
                :data-title="$t('DURATION') + ' (' + $t('HOUR') + ')'"
              >
                {{ calculateHour(scope.row.duration) }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            :align="$i18n.locale == 'fa' ? 'right' : 'left'"
            :label="$t('START_TIME')"
            min-width="150"
          >
            <template slot-scope="scope">
              <div class="text-sm" :data-title="$t('START_TIME')">
                {{ formatPersianDate(scope.row.start_datetime) }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            :align="$i18n.locale == 'fa' ? 'right' : 'left'"
            :label="$t('END_TIME')"
            min-width="150"
          >
            <template slot-scope="scope">
              <div class="text-sm" :data-title="$t('END_TIME')">
                {{ formatPersianDate(scope.row.end_datetime) }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            :align="$i18n.locale == 'fa' ? 'right' : 'left'"
            :label="$t('ADDRESS')"
            min-width="250"
          >
            <template slot-scope="scope">
              <div class="text-sm" :data-title="$t('ADDRESS')">
                {{ formatAddress(scope.row.place.address) }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import config from '@/configs/configs.js'
import { movingMarkerSrc } from '@/mixins/movingMarker'
import { stopDownload } from '@/api/reports'
import { calculateHour } from '@/mixins/calculateHour'
import Field from '@/components/elements/field'
import HintLabels from '../../elements/HintLabels.vue'

export default {
  props: [
    'path',
    'tripDetail',
    'realtime',
    'vehicleId',
    'startDateTime',
    'endDateTime',
    'minDuration',
    'quality',
  ],
  mixins: [movingMarkerSrc, calculateHour],
  components: {
    Field,
    HintLabels,
  },
  data() {
    return {
      map: null,
      history: null,
      isDownloadLoading: false,
      anomalyTypes: [
        this.$t('START_POINT'),
        this.$t('END_POINT'),
        this.$t('stops_in_order'),
      ],
      colors: ['darkgreen', 'darkblue', '#d14'],
    }
  },

  methods: {
    downloadReport() {
      this.isDownloadLoading = true
      stopDownload
        .api([
          this.vehicleId,
          this.startDateTime,
          this.endDateTime,
          this.minDuration,
        ])
        .then((res) => {
          this.isDownloadLoading = false
          if (res) {
            var blob = new Blob([res], { type: 'application/octet-stream' })

            const url = window.URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.style.display = 'none'
            a.href = url
            a.download = `stops-CARPO.xlsx`
            document.body.appendChild(a)
            a.click()

            window.URL.revokeObjectURL(url)
          }
        })
        .catch((error) => {
          console.error('Download Error:', error)
        })
    },
    loadMap() {
      var map = L.map(this.$refs['mapElement'], { tap: false }).setView(
        [this.history.start_location[1], this.history.start_location[0]],
        12
      )
      L.tileLayer(config.tile, {
        attribution: '@ Carpo',

        id: 'mapbox/streets-v11',
        tileSize: 512,
        zoomOffset: -1,
        accessToken: config.leaflet,
      }).addTo(map)
      this.map = map

      const startLocation = [
        this.history.start_location[1],
        this.history.start_location[0],
      ]
      const endLocation = [
        this.history.end_location[1],
        this.history.end_location[0],
      ]

      const startMarker = L.marker(startLocation, {
        icon: this.generatePulsatingMarker(20, 'darkgreen'),
        fillOpacity: 0.6,
      })

      map.addLayer(startMarker)

      startMarker.bindPopup(
        `
          <div class='text-center'>
          <strong class='text-sm text-green-800'>${this.$i18n.t(
            'START_POINT'
          )}</strong>
          </div>
        `,
        { minWidth: 100 }
      )

      const endtMarker = L.marker(endLocation, {
        icon: this.generatePulsatingMarker(20, 'darkblue'),
        fillOpacity: 0.6,
      })

      map.addLayer(endtMarker)

      endtMarker.bindPopup(
        `
          <div class='text-center'>
          <strong class='text-sm text-blue-800'>${this.$i18n.t(
            'END_POINT'
          )}</strong>
          </div>
        `,
        { minWidth: 100 }
      )

      this.handleOpenClosePopup(endtMarker)

      const stops = this.history.stops.map((stop) => ({
        location: [stop.location[1], stop.location[0]],
        start_datetime: stop.start_datetime,
        end_datetime: stop.end_datetime,
      }))

      this.createCurvedPath(
        map,
        startLocation,
        stops[0].location,
        this.startDateTime,
        stops[0].end_datetime,
        false,
        true
      )

      this.history.stops.forEach((stop, index) => {
        this.addMarker(map, stop, index)
      })

      for (let i = 0; i < stops.length - 1; i++) {
        this.createCurvedPath(
          map,
          stops[i].location,
          stops[i + 1].location,
          stops[i].end_datetime,
          stops[i + 1].start_datetime,
          true,
          true
        )
      }

      this.createCurvedPath(
        map,
        stops[stops.length - 1].location,
        endLocation,
        stops[stops.length - 1].end_datetime,
        this.endDateTime,
        true,
        false
      )
    },
    createCurvedPath(
      map,
      startLocation,
      endLocation,
      startDateTime,
      endDateTime,
      convertableStart = true,
      convertableEnd = true
    ) {
      const color = this.getRandomColor()
      const offsetX = endLocation[1] - startLocation[1]
      const offsetY = endLocation[0] - startLocation[0]
      const r = Math.sqrt(Math.pow(offsetX, 2) + Math.pow(offsetY, 2))
      const theta = Math.atan2(offsetY, offsetX)
      const thetaOffset = 3.14 / 10
      const theta2 = theta + thetaOffset
      const r2 = r / 2 / Math.cos(thetaOffset)
      const midpointX = r2 * Math.cos(theta2) + startLocation[1]
      const midpointY = r2 * Math.sin(theta2) + startLocation[0]
      const midpointLatLng = [midpointY, midpointX]

      const pathOptions = {
        color,
        weight: 5,
      }

      const curvedPath = L.curve(
        ['M', startLocation, 'Q', midpointLatLng, endLocation],
        pathOptions
      ).addTo(map)

      this.handleClickOnCurve(
        curvedPath,
        endLocation,
        startDateTime,
        endDateTime,
        convertableStart,
        convertableEnd
      )
    },
    handleClickOnCurve(
      curveLine,
      startLoc,
      startDateTime,
      endDateTime,
      convertableStart,
      convertableEnd
    ) {
      const startRange = convertableStart
        ? this.convertToTimestamp(startDateTime)
        : startDateTime

      const endRange = convertableEnd
        ? this.convertToTimestamp(endDateTime)
        : endDateTime

      curveLine.on('click', () => {
        const popupContent = `
            <div class="py-1 flex flex-col-reverse items-center gap-1 justify-center"><a style="color: darkblue" target="_blank" href="/reports/history/v3overview/details/${
              this.vehicleId
            }?start_range=${startRange}&stop_range=${endRange}&quality=${
          this.quality
        }">${this.$i18n.t('TRIP_DETAIL_v3')}</a>
          </div>
            `

        L.popup().setLatLng(startLoc).setContent(popupContent).openOn(this.map)
      })
    },
    convertToTimestamp(datetimeString) {
      Date.prototype.getUTCTime = function () {
        return this.getTime() - this.getTimezoneOffset() * 60000
      }

      return new Date(datetimeString).getUTCTime() / 1000
    },
    getRandomColor() {
      const letters = '0123456789ABCDEF'
      let color = '#'
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)]
      }
      return color
    },
    addMarker(map, detail, index) {
      const indexIcon = L.divIcon({
        className: 'index-icon',
        html: `<div>${index + 1}</div>`,
      })

      const marker = L.marker([detail.location[1], detail.location[0]], {
        icon: indexIcon,
      })

      map.addLayer(marker)

      marker.bindPopup(
        `
          <div class="divide-y divide-gray-200 text-right leading-6	">
          

          ${this.popupDetail(
            this.$i18n.t('STOPPING_POINT') + ': ',
            `${index + 1}`
          )}

          ${this.popupDetail(
            this.$i18n.t('DURATION') + ' (' + this.$i18n.t('HOUR') + ') :',
            `${this.calculateHour(detail.duration)}`
          )}

          
          
        ${this.popupDetail(
          this.$i18n.t('START_TIME'),
          `${this.formatPersianDate(detail.start_datetime)} `
        )}

          ${this.popupDetail(
            this.$i18n.t('END_TIME'),
            `${this.formatPersianDate(detail.end_datetime)} `
          )}

          ${this.popupDetail(
            this.$i18n.t('ADDRESS'),
            `${this.formatAddress(detail.address)}`
          )}

          </div>
        `,
        { minWidth: 250 }
      )
      this.handleOpenClosePopup(marker)
    },

    handleOpenClosePopup(marker) {
      marker.on('mouseover', function () {
        marker.openPopup()
      })

      marker.on('mouseout', function () {
        marker.closePopup()
      })
    },
    formatPersianDate(date) {
      const persianDate = new Date(date)
      persianDate.setMinutes(persianDate.getMinutes() + 210) // Adjust for Tehran timezone (3 hours and 30 minutes ahead of UTC)

      return persianDate.toLocaleString('fa-IR')
    },

    formatAddress(address) {
      if (!address) return '-'

      const addressParts = []

      if (address.province || address.state)
        addressParts.push(address.province || address.state)
      if (address.city) addressParts.push(address.city)
      if (address.suburb) addressParts.push(address.suburb)
      if (address.neighbourhood) addressParts.push(address.neighbourhood)
      if (address.road) addressParts.push(`${address.road}`)

      return addressParts.length > 0 ? addressParts.join('، ') : '-'
    },

    showSpeed(path) {
      path.on('click', (ev) => {
        var latlng = this.map.mouseEventToLatLng(ev.originalEvent)
        for (var i = 0; i < this.uniqPath.length; i++) {
          if (
            this.distance(
              latlng.lat,
              latlng.lng,
              this.uniqPath[i][0],
              this.uniqPath[i][1],
              'K'
            ) <= 0.04
          ) {
            this.popupMaker(
              'SPEED',
              [this.uniqPath[i][0], this.uniqPath[i][1]],
              `<span class="flex ltr"> ${this.tripDetail.speeds[i]} Km/h</span>`,
              this.tripDetail.datetimes[i]
            )
            break
          }
        }
      })
    },
    generatePulsatingMarker(radius, color) {
      const cssStyle = `
        width: ${radius}px;
        height: ${radius}px;
        background: ${color};
        color: ${color};
        box-shadow: 0 0 0 ${color};
      `
      return L.divIcon({
        html: `<span style="${cssStyle}" class="pulse"></span>`,
        className: '',
        fillOpacity: 0.6,
      })
    },
    onEachFeature(feature, layer) {
      if (feature) {
        layer.bindPopup(
          `${this.popupDetail(
            this.$t('ANOMALY_DETECT') + ':',
            this.anomalyTypes[feature.properties.anomaly - 1]
          )}`
        )
      }
    },

    popupDetail(title, content) {
      return content != null && content != ''
        ? `<div class="py-1 flex justify-between items-center"> <span class="text-gray-500">${title} </span> <span class="capitalize font-bold">${content}</span> </div>`
        : ''
    },

    popupMaker(content, latlong, content2 = '', date) {
      L.popup({ maxWidth: 200 })
        .setLatLng(latlong)
        .setContent(
          `
        <div class="py-1 flex flex-col  gap-2">
          <div class="flex flex-row items-center justify-between items-center gap-2 w-full">
              <span class="text-gray-500">${this.$i18n.t(content)}: </span>
              <div class="flex items-center space-x-1 flex-row-reverse	"><span class="capitalize font-bold">${content2}</span> </div>
            </div>
            <div class="flex flex-row items-center justify-between items-center gap-2 w-full">
              <span class="text-gray-500">${this.$i18n.t('TIME')}: </span>
              <span class="capitalize font-bold">
                ${new Date(date).toLocaleDateString(
                  'fa-IR'
                )} <span class="text-gray-500 symbol mx-1">|</span>
                ${new Date(date).toLocaleTimeString('fa-IR')}
              </span>
            </div>
        </div>
        `
        )
        .addTo(this.map)
    },

    handleStopRowClick(row) {
      console.log(row)
      // Convert location coordinates [lng, lat] to [lat, lng] for Leaflet
      const lat = row.location[1]
      const lng = row.location[0]

      // Zoom to the location with a higher zoom level for better view
      this.map.setView([lat, lng], 16)

      // Optional: Add a temporary highlight or pulse effect
      const marker = L.circleMarker([lat, lng], {
        radius: 15,
        fillColor: '#ff7800',
        color: '#000',
        weight: 2,
        opacity: 1,
        fillOpacity: 0.8,
      }).addTo(this.map)

      // Remove the highlight marker after 3 seconds
      setTimeout(() => {
        this.map.removeLayer(marker)
      }, 3000)
    },
  },
  mounted() {
    this.history = this.tripDetail
    this.$nextTick(() => {
      this.loadMap()
    })
  },
}
</script>
<style>
#map {
  z-index: 9;
  height: 500px;
  width: 100%;
}
.index-icon {
  text-align: center;
  color: white;
  background-color: #d14;
  padding: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  font-size: 10px;
}

/* Stops Table Styling */
.stops-table-container {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}

.stops-table .el-table__row {
  transition: background-color 0.2s ease;
}

.stops-table .el-table__row:hover {
  background-color: #f8fafc !important;
  cursor: pointer;
}

.stops-table .el-table__header {
  background-color: #f1f5f9;
}

.stops-table .el-table__header th {
  background-color: #f1f5f9 !important;
  color: #475569;
  font-weight: 600;
}

.stops-table .el-table__body-wrapper {
  max-height: 300px;
  overflow-y: auto;
}

/* Scrollbar styling */
.stops-table .el-table__body-wrapper::-webkit-scrollbar {
  width: 6px;
}

.stops-table .el-table__body-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.stops-table .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 10px;
}

.stops-table .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Responsive adjustments */
/* @media (max-width: 768px) {
  .stops-table-container {
    overflow-x: auto;
  }

  .stops-table {
    min-width: 600px;
  }
} */
</style>
